export default __webpack_public_path__ + "static/65-234075447ab80a6b71c40fc2b16bc5f0.png";